<template>
    <div class="mt-2 flex flex-col w-full">
        <div class="w-full shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="table-default" v-if="auction && auction.levels && auction.levels.length > 0">
                <thead>
                    <tr>
                        <th scope="col" class="hidden xl:table-cell">{{$t('shared.pyramid_auction.levels.table_columns.level')}}</th>
                        <th scope="col" class="hidden xl:table-cell">{{$t('shared.pyramid_auction.levels.table_columns.price_drop')}}</th>
                        <th scope="col" class="hidden xl:table-cell">{{$t('shared.pyramid_auction.levels.table_columns.time')}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.duration')}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.price')}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.qty_sold')}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.floor_sales' + this.$page.props.tenant.labels_key)}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.merch_sales' + this.$page.props.tenant.labels_key)}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.number_of_visitors')}}</th>
                        <th scope="col">{{$t('shared.pyramid_auction.levels.table_columns.bids_per_visitors')}}</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-for="(level, index) in auction.levels"
                        :key="level.id"
                        class="break-page"
                        :class="{
                                'bg-gray-50': level.phase % 2 === 1,
                                'price-drop': level.price_drop === 1 || index === 0
                            }">
                        <td class="hidden xl:table-cell">{{ level.sequence }}</td>
                        <td class="hidden xl:table-cell"><icon v-if="level.price_drop === 1" name="badge-check" class="h-6 w-6"/></td>
                        <td class="hidden xl:table-cell">{{ level.date_started | formatTime }} {{ level.date_started | formatTimeAmPm }}</td>
                        <td v-if="levelDuration(level) === false">
                                <auction-state state="skipped"/>
                        </td>
                        <td v-if="levelDuration(level) !== false">{{ levelDuration(level, index) }}</td>
                        <td>{{ level.price | toCurrency }}</td>
                        <td>{{ level.quantity_used }}</td>
                        <td>{{ floorSales(level, index) | toCurrency}}</td>
                        <td>{{ merchSalesForLevel(level) | toCurrency}}</td>
                        <td>{{ numberOfVisitors(level) }}</td>
                        <td>{{ bidsPerVisitors(level) }}</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!auction || !auction.levels || auction.levels.length < 1" class="m-3">{{$t('shared.pyramid_auction.no_levels')}}</div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import PageHeadline from "@/Shared/PageHeadline";
import moment from 'moment';
import AuctionState from "../Auction/AuctionState";

export default {
    components: {
        AuctionState,
        Link,
        Icon,
        PageHeadline
    },
    props: {
        auction: Object,
        merchSales: Array,
        performanceDetails: Object
    },
    methods: {
        floorSales(level) {
            return level.quantity_used * level.price;
        },
        merchSalesForLevel(level) {
            return this.merchSales.find(s => s.sequence == level.sequence)?.merch_sales || 0;
        },
        levelDuration(level) {
            let start = moment(level.date_started); // some random moment in time (in ms)
            let end = moment(level.date_ended)
            if (start._isValid && !end._isValid) {
                end = moment(this.auction.date_ended);
            }
            this.auction.date_ended; // some random moment after start (in ms)
            return (end._isValid && start._isValid) ?
                moment.utc(end.diff(start)).format("HH:mm") + ' ' + this.$t('shared.hours') :
                false;
        },
        numberOfVisitors(level) {
            return Object.values(this.performanceDetails?.visitors_per_level)?.find((i) => i.level_id === level.id)?.visitor_count || '-';
        },
        numberOfBids(level) {
            return this.auction.bids?.filter(b => b.level_id === level.id)?.length || 0;
        },
        bidsPerVisitors(level) {
            let visitorCount = this.numberOfVisitors(level);
            let bidCount = this.numberOfBids(level);
            return visitorCount > 0 ? Math.floor(bidCount / visitorCount * 100) : '-';
        },
    }
}
</script>
